import {
	ACTIVE, ACTIVE_STATUS, INACTIVE, INACTIVE_STATUS, INVITED, INVITED_STATUS, NOT_RESULT_FOUND
} from './constants';
import moment from 'moment';


const columnNamesUsers = {
	name: <b>Nombre</b>,
	lastName: <b>Apellido</b>,
	email: <b>Email</b>,
	role: <b>Rol</b>,
	inspector: <b>Inspector</b>,
	supervisor: <b>Supervisor</b>,
	createdAt: <b>F. creación</b>,
	currentStatus: <b>Estado</b>,
	internalIdentifier: <b>Cod. interno</b>,
	dni: <b>DNI</b>,
	isActive: <b>Usuario activo</b>,
	needsPasswordReset: <b>Usuario restablecido</b>,

};
const columnNamesInspections = {
	inspectorFullName: <b>Inspector</b>,
	id: <b>Id</b>,
	inspectorInternalCode: <b>Cod. Inspector</b>,
	establishmentCode: <b>Cod. Establecimiento</b>,
	startDate: <b>F. de inicio</b>,
	endDate: <b>F. de fin</b>,
	inspectionType: <b>Tipo de monitoreo</b>,
	inspectionStartDate: <b>F. inicio inspección</b>,
	inspectionEndDate: <b>F. fin inspección</b>,
	currentStatus: <b>Estado</b>,
	internalIdentifier: <b>Cod. interno</b>,
	isActive: <b>Usuario activo</b>,
	establishmentName: <b>Establecimiento</b>,
	establishmentZone: <b>Zona</b>,
	inspectionExportZone: <b>Zona de exportación</b>,
	establishmentDirection: <b>Dirección</b>,
	upCode: <b>Cod. UP</b>
};

export const getNameByUsersKey = (item) => columnNamesUsers[item] || item;
export const getNameByInspectionsKey = (item) => columnNamesInspections[item] || item;

export const getDateFormatted = (date) => {
	if (date !== "") {
		return moment.utc(date).format('DD/MM/YYYY')
	}
	else
		return "--"
	
};
export const getDateFormattedInspection = (date) => {
	if (date !== "") {
		return moment.utc(date).format('DD/MM/YYYY - h:mm')
	}
	else
		return "--"
	
};
export const getFullName = (name, lastname) => {
	var fullName = name + '' + lastname
	return fullName
};
export const getBoolean = (item) => {
	if (item === true) {
		return "Si"
	}
	else {
		return "No"
	}
};


export const baseParams = { page: 1, pageSize: 10 };

export const initialPagination = {
	current: 1,
	pageSize: 10,
	total: null
};

export const initialFilters = {
	keyword: '',
};

export const layoutNewForm = {
	labelCol: {
		span: 6
	},
	wrapperCol: {
		span: 12
	}
};

export const localeText = { emptyText: 'No hay datos ingresados' };

export const getIdFromPath = (path = '') => path.split('/').pop();


export const status = [
	{ key: ACTIVE_STATUS, name: ACTIVE },
	{ key: INVITED_STATUS, name: INVITED },
	{ key: INACTIVE_STATUS, name: INACTIVE }
];

